<div
  *ngIf="sheduleSuggestionsContainersToShow.addSuggestion"
  class="suggestion"
  (click)="openSchedulingSuggestionsDialog()"
>
  <span class="suggestion__text">
    {{ 'MAINTENANCES.CREATE_DIALOG.ADD_SUGGESTION' | translate }}
  </span>
</div>

<div *ngIf="sheduleSuggestionsContainersToShow.ongoingSuggestions" class="ongoing-suggestions">
  <span class="ongoing-suggestions__title">
    {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.TITLE' | translate }}
    ({{ scheduleSuggestionsFormArray?.value?.length }}/3)
  </span>
  <div class="ongoing-suggestions__content">
    <div class="ongoing-suggestions__content__suggestions">
      <div
        *ngFor="let scheduleSuggestions of scheduleSuggestionsFormArray?.value; index as index"
        class="ongoing-suggestions__content__suggestions__suggestion"
      >
        <span class="ongoing-suggestions__content__suggestions__suggestion__title">
          {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.SUGGESTION' | translate }} {{ index + 1 }}
        </span>
        <span class="ongoing-suggestions__content__suggestions__suggestion__datetime">
          {{ scheduleSuggestions.date | date: 'dd/MM/yyyy' }}
          {{ scheduleSuggestions.time | removeTimeSeconds }}
        </span>
      </div>
    </div>

    <div class="ongoing-suggestions__content__buttons" *ngIf="shouldShowButtonsOnOngoingScheduleSuggestions">
      <button (click)="openSchedulingSuggestionsDialog()" class="ongoing-suggestions__content__buttons__edit">
        <span class="ongoing-suggestions__content__buttons__edit__text">
          {{ 'MAINTENANCES.CREATE_DIALOG.SCHEDULING_SUGGESTIONS_DIALOG.EDIT_SUGGESTIONS' | translate }}
        </span>
      </button>
      <button
        (click)="openConfirmDeleteNewSchedulingSuggestionsDialog()"
        class="ongoing-suggestions__content__buttons__delete"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <div
    class="schedule-suggestions__error"
    *ngIf="corporateScheduleSuggestionsHasRetroactiveDate && shouldShowButtonsOnOngoingScheduleSuggestions"
  >
    <mat-icon class="schedule-suggestions__error__icon">info</mat-icon>
    <span class="schedule-suggestions__error__message">
      {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.ERRORS.RETROACTIVE_DATE_GENERIC' | translate }}
    </span>
  </div>
</div>

<div *ngIf="sheduleSuggestionsContainersToShow.corporateAccepted" class="corporate-accepted">
  <span class="corporate-accepted__title">
    {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.TITLE' | translate }}
  </span>
  <span class="corporate-accepted__description">
    {{
      'MAINTENANCES.SCHEDULE_SUGGESTIONS.ACCEPT_MAINTENANCE_SCHEDULE_SUGGESTIONS.DESCRIPTION'
        | translate
          : {
              date: form.get('companyScheduleSuggestion')?.value?.date | date: 'dd/MM/yyyy',
              time: form.get('companyScheduleSuggestion')?.value?.time
                ? (form.get('companyScheduleSuggestion')?.value?.time | removeTimeSeconds)
                : ''
            }
    }}
  </span>
</div>

<div class="schedule-suggestions" *ngIf="sheduleSuggestionsContainersToShow.scheduleSuggestions">
  <span class="schedule-suggestions__title">
    {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.TITLE' | translate }}
  </span>
  <span class="schedule-suggestions__description">
    {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.DESCRIPTION' | translate }}
  </span>
  <div class="schedule-suggestions__footer">
    <div class="schedule-suggestions__footer__suggestion">
      <span class="schedule-suggestions__footer__suggestion__title">
        {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.NEW_SUGGESTION' | translate }}
      </span>
      <span class="schedule-suggestions__footer__suggestion__datetime">
        {{ form.get('companyScheduleSuggestion')?.value?.date | date: 'dd/MM/yyyy' }}
        {{ form.get('companyScheduleSuggestion')?.value?.time | removeTimeSeconds }}
      </span>
    </div>
    <div class="schedule-suggestions__footer__buttons">
      <button
        class="schedule-suggestions__footer__buttons__accept"
        (click)="acceptMaintenanceScheduleSuggestions()"
        [disabled]="companyScheduleSuggestionIsRetroactiveDate"
      >
        {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.BUTTONS.ACCEPT_SUGGESTION' | translate }}
      </button>
      <button
        class="schedule-suggestions__footer__buttons__suggesting-again"
        (click)="openSchedulingSuggestionsDialog()"
      >
        {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.BUTTONS.SUGGESTING_AGAIN' | translate }}
      </button>
      <button
        class="schedule-suggestions__footer__buttons__stop-suggesting"
        (click)="openStopSchedulingSuggestionsDialog()"
      >
        <mat-icon
          class="schedule-suggestions__footer__buttons__stop-suggesting__icon"
          matTooltip="{{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.BUTTONS.STOP_SUGGESTING' | translate }}"
        >
          delete
        </mat-icon>
      </button>
    </div>
  </div>
  <div class="schedule-suggestions__error" *ngIf="companyScheduleSuggestionIsRetroactiveDate">
    <mat-icon class="schedule-suggestions__error__icon">info</mat-icon>
    <span class="schedule-suggestions__error__message">
      {{ 'MAINTENANCES.SCHEDULE_SUGGESTIONS.ERRORS.RETROACTIVE_DATE' | translate }}
    </span>
  </div>
</div>
